<!--TRENDING--->
<section class="touch-slider-wrp mt-5 position-relative trending-wrp" *ngIf="responseReceived && products.length > 0">
  <div class="container">
    <div class="touch-slider-wrp-inner">

      <h4 class="heading-w-border mb-2 colorWhite">
        <span>Trending in {{_categoryName}}</span>
      </h4>

      <div class="touch-slider">
        <div uk-slider>
          <div class="uk-position-relative">

            <div class="uk-slider-container uk-light mt-5">
              <ul
                class="uk-slider-items uk-child-width-1-2 uk-child-width-1-2@s uk-child-width-1-4@m uk-grid-small uk-flex-middle"
                uk-grid>

                <li *ngFor="let product of products">
                  <div class="trending-card">
                    <a [routerLink]="['/' + product.city.name.toLowerCase() + '/' + product.slug]">
                      <div class="image">
                        <img src="{{product.featured_image}}" alt="">
                      </div>
                      <div class="logo">
                       <!-- <img src="{{product.merchant.logo}}" alt="">-->
                       <p>{{product.merchant.merchant_name}}</p>
                      </div>
                      <h5>
                        <i class="fa fa-map-marker"></i>  All Outlet
                      </h5>
                      <div class="info">
                        <p>Packages starting from</p>
                        <h4><i
                          class="fa fa-rupee fa-rupee-small"></i> {{product.cheapest_standard_deal.sale_price | currency:'INR':'':'1.0-0'}}
                        </h4>
                      </div>
                    </a>
                  </div>
                </li>

              </ul>
            </div>
            <!--uk-slider-container--->

            <a class="uk-position-center-left-out custom-nav" href="#" uk-slidenav-previous uk-slider-item="previous">
              <!-- <img src="assets/images/icons/arrow-right.png" alt=""> -->
              <img src="assets/images/christmas/white-left-arrow.png" alt="">
            </a>
            <a class="uk-position-center-right-out custom-nav" href="#" uk-slidenav-next uk-slider-item="next">
              <!-- <img src="assets/images/icons/arrow-right.png" alt=""> -->
              <img src="assets/images/christmas/white-left-arrow.png" alt="">
            </a>
          </div>
        </div>

      </div>
      <!--touch-slider-wrp-inner--->
    </div>
  </div>
  <!--container--->
</section>


<!--Loader--->
<section class="touch-slider-wrp mt-5 position-relative trending-wrp" *ngIf="!responseReceived" hidden>
  <div class="container">
    <div class="touch-slider-wrp-inner">

      <h4 class="heading-w-border mb-2">
        <ngx-skeleton-loader animation="progress" appearance="line"></ngx-skeleton-loader>
      </h4>

      <div class="touch-slider trending-wrp-skeleton">
        <div uk-slider>
          <div class="uk-position-relative">

            <div class="uk-slider-container uk-light mt-5">
              <ul
                class="uk-slider-items uk-child-width-1-2 uk-child-width-1-3@s uk-child-width-1-4@m uk-grid-small uk-flex-middle"
                uk-grid uk-scrollspy="cls: uk-animation-fade; target: li; delay: 300; repeat: false">

                <li *ngFor="let product of [1,2,3,4]">
                  <ngx-skeleton-loader animation="progress" appearance="line"></ngx-skeleton-loader>
                </li>

              </ul>
            </div>
            <!--uk-slider-container--->
          </div>
        </div>

      </div>
      <!--touch-slider-wrp-inner--->
    </div>
  </div>
  <!--container--->
</section>
